<template>
    <MediaImage
        :class="cssClass"
        :style="cssStyle"
        :data="data"
        :breakpoint="breakpoint"
        :alt-text="configLocal.altText"
        :plain-image="configLocal.plainImage"
        :contain="configLocal.contain"
        :auto-responsive="configLocal.autoResponsive"
        :fluid-width="configLocal.fluidWidth"
        :fill-height="configLocal.fillHeight"
        :fill-width="configLocal.fillWidth"
        :position="configLocal.position"
        :rounded="configLocal.rounded"
    ></MediaImage>
</template>

<script lang="ts" setup>
    import type {
        ContentImage,
        ContentBlocksComponentProps,
        BreakpointType,
        ContentBlockThemeStyleItems,
        ContentBlockImageStatic,
        ContentBlockImageStaticConfigBase
    } from '~/types';
    import { merge as lo_mergeCompat } from 'es-toolkit/compat';
    import { legacyContentHelpers } from '~/composables';
    import MediaImage from '~/components/content/MediaImage/MediaImage.vue';

    const props = withDefaults(
        defineProps<ContentBlocksComponentProps<ContentBlockImageStatic>>(),
        {
            theme: 'light',
            breakpoint: 'desktop',
            breakpointName: 'md'
        }
    );

    const { getBreakpointItem } = legacyContentHelpers;
    const data = computed<Nilish<ContentImage>>(() => props.config.theme?.[props.theme]);

    const cssClass = ref<string[]>([]);
    const cssStyle = ref<Record<string, string>>({});
    const configLocal = ref<Partial<ContentBlockImageStaticConfigBase>>({});

    const unWatchTheme = watch(
        () => props.breakpointName,
        (newBreakpointName) => {

            const mediaConfig = getBreakpointItem<Undefinable<Partial<ContentBlockImageStaticConfigBase>>>(
                newBreakpointName,
                props.config.breakpoint
            ) ?? {};

            configLocal.value = lo_mergeCompat<
                ContentBlockImageStaticConfigBase,
                Partial<ContentBlockImageStaticConfigBase>,
                Partial<ContentBlockImageStaticConfigBase>
            >({} as ContentBlockImageStaticConfigBase, props.config.base, mediaConfig);


            if (props.config.component?.breakpoint) {
                const cmpConfig = getBreakpointItem<ContentBlockThemeStyleItems>(
                    newBreakpointName,
                    props.config.component.breakpoint
                );

                if (cmpConfig) {
                    cssClass.value = cmpConfig.cssClass ?? [];
                    cssStyle.value = cmpConfig.cssStyle ?? {};
                }
            }
        },
        {
            immediate: true
        }
    );

    onBeforeUnmount(() => {
        unWatchTheme();
    });
</script>

<style lang="scss"></style>
